/* Orga+ home: swipe dots, reels (tap to play, one at a time), reveals. */
(function () {
  function initDots(root) {
    var track = root.querySelector('[data-oh-track]');
    var dots = root.querySelectorAll('[data-oh-dots] i');
    if (!track || !dots.length || track.dataset.ohReady) return;
    track.dataset.ohReady = '1';
    var items = Array.prototype.slice.call(track.children);
    function sync() {
      var best = 0, bestD = Infinity, left = track.getBoundingClientRect().left;
      items.forEach(function (el, i) { var d = Math.abs(el.getBoundingClientRect().left - left - 20); if (d < bestD) { bestD = d; best = i; } });
      dots.forEach(function (d, i) { d.classList.toggle('is-on', i === best); });
    }
    track.addEventListener('scroll', function () { window.requestAnimationFrame(sync); }, { passive: true });
    sync();
  }

  function initReels(root) {
    if (root.dataset.ohReels === 'ready') return;
    root.dataset.ohReels = 'ready';
    var reels = root.querySelectorAll('.oh-reel');
    function stopAll(except) {
      reels.forEach(function (r) { var v = r.querySelector('video'); if (r !== except && v && !v.paused) { v.pause(); } });
    }
    reels.forEach(function (reel) {
      var v = reel.querySelector('video');
      var btn = reel.querySelector('[data-oh-reel-play]');
      v.addEventListener('play', function () { reel.classList.add('is-playing'); });
      v.addEventListener('pause', function () { reel.classList.remove('is-playing'); });
      btn.addEventListener('click', function () {
        if (!v.src) { v.src = v.dataset.src; }
        if (v.paused) { stopAll(reel); v.muted = false; v.play().catch(function () { v.muted = true; v.play().catch(function () {}); }); }
        else { v.pause(); }
      });
    });
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        entries.forEach(function (e) { if (!e.isIntersecting) stopAll(null); });
      }, { threshold: 0 }).observe(root);
    }
  }

  function initReveal() {
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches || !('IntersectionObserver' in window)) return;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) { if (e.isIntersecting) { e.target.classList.remove('oh-rv--wait'); io.unobserve(e.target); } });
    }, { threshold: 0.12 });
    document.querySelectorAll('.oh-rv').forEach(function (el) {
      if (el.dataset.ohRv) return; el.dataset.ohRv = '1';
      if (el.getBoundingClientRect().top < window.innerHeight) return;
      el.classList.add('oh-rv--wait'); io.observe(el);
    });
  }

  function boot() {
    document.querySelectorAll('.oh-problems, .oh-reels, .oh-expect').forEach(initDots);
    document.querySelectorAll('[data-oh-reels]').forEach(initReels);
    initReveal();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();
